import(/* webpackMode: "eager" */ "/app/apps/gift/src/app/global-error.tsx");
